import { createTheme } from '@mui/material/styles'

const theme = createTheme({
  palette: {
    links: {
      main: '#024579',
    },
  },
})

const Styles = {
  fontFamily:
    '"Noto Sans", "San Francisco", Roboto, "Segoe UI", "Helvetica Neue", sans-serif',
  display: 'flex',
  justifyContent: 'flex-end',
  whiteSpace: 'nowrap',
  paddingTop: '10px',
  paddingBottom: '2px',
  minWidth: '320px',
  '& > a': {
    fontFamily:
      '"Noto Sans", "San Francisco", Roboto, "Segoe UI", "Helvetica Neue", sans-serif',
    color: `${theme.palette.links.main}`,
    fontSize: '12px',
    fontWeight: 'medium',
    height: '17px',
    padding: '3px 35px 6px 15px',
    '&:hover': {
      cursor: 'pointer',
      color: '#888863',
    },
    '& > a:visited': {
      fontFamily:
        '"Noto Sans", "San Francisco", Roboto, "Segoe UI", "Helvetica Neue", sans-serif',
    },
  },

  tenantSwitcherList: {
    display: 'none',
    borderRadius: '0px',
    border: '1px solid #aaa',
    borderTop: 'none',
    borderTopRightRadius: '0',
    background: 'padding-box #fff',
    maxHeight: 'calc(100vh - 130.5px)',
    minHeight: '301.5px',
    overflow: 'scroll',
    overflowX: 'hidden',
    padding: '25px 20px 10px',
    position: 'absolute',
    marginTop: '1.45em',

    top: '28.5px',
    left: '0px',
    width: '280px',
    zIndex: '20',
    a: {
      whiteSpace: 'break-spaces',
      display: 'flex',
      alignItems: 'center',
      alignContent: 'center',
      marginBottom: '16px',
      marginLeft: '8px',
    },
    'a:visited': {
      color: `${theme.palette.links.main}`,
    },
  },

  tenantSwitcherActive: {
    display: 'block',
  },
  tenantSwitcherInActive: {
    display: 'none',
  },

  switcherOption: {
    color: `${theme.palette.links.main}`,
    clear: 'both',
    display: 'block',
    marginBottom: '10px',
    '&:hover': {
      color: '#888863!important',
      cursor: 'pointer',
    },
  },

  tenantSwitcherFilterWrapper: {
    marginBottom: '20px',
    width: 'calc(100% - 16px)',
    marginRight: '8px',
    marginLeft: '8px',
  },

  signInImage: {
    display: 'flex',
    overflow: 'hidden',
    alignItems: 'center',
    justifyContent: 'center',
    width: '75px',
    height: '75px',
    border: '1px solid #aaa',
    float: 'left',
    marginRight: '10px',
    padding: '10px',
    '&:hover': {
      cursor: 'pointer',
    },
    img: {
      objectFit: 'contain',
      maxWidth: '100%',
      width: '75px',
      height: '75px',
    },
  },

  tenantName: {
    display: 'flex',
    alignItems: 'center',
    lineHeight: 'normal',
    paddingRight: '16px',

    span: {
      fontFamily:
        '"Noto Sans", "San Francisco", Roboto, "Segoe UI", "Helvetica Neue", sans-serif',
      width: '14em',
      margin: '0 auto',
      position: 'absolute',
      overflowWrap: 'break-word',
      display: 'table-cell',
      verticalAlign: 'middle',
    },
  },

  accountLessMessage: {
    borderRadius: '2px',
    backgroundColor: '#00877c',
    color: 'white',
    fontSize: '9px',
    fontWeight: 'bold',
    padding: '3px 7px',
  },
  tag: {
    fontSize: '12px',
    fontWeight: '400',
    marginTop: '-70px',
    color: 'white',
    paddingTop: '2px',
    paddingBottom: '2px',
    position: 'absolute',
    right: 15,
    zIndex: 5,
  },

  dropDown: {
    position: 'relative',
    display: 'inline-block',
    width: '106.4%',
    zIndex: 10,
    input: {
      display: 'block',
      margin: '0.5em',
      padding: '0.5em',
      width: '90%',
      border: '1px solid #aaa',
      borderRadius: '0px',
    },
    dropBtn: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      backgroundColor: '#fff',
      color: '#999898',
      lineHeight: '28px',
      height: '32px',
      fontSize: '16px',
      padding: '6px',
      border: '1px solid #aaa',
      cursor: 'pointer',
      '&:focus': {
        borderRadius: '0px',
      },
      span: {
        fontSize: '14px',
        fontWeight: '400',
        fontColor: '#333333',
        padding: '2px 0 1px 2px',
      },
    },
    arrow: {
      borderColor: '#aaaaaa transparent transparent transparent',
      borderStyle: 'solid',
      borderWidth: '7px 4px 2px 4px',
    },
    selectedArrow: {
      borderColor: 'transparent transparent #aaaaaa transparent',
      borderStyle: 'solid',
      borderWidth: '0 4px 5px 4px',
    },
    rotatedArrow: {
      borderColor: 'transparent transparent #aaaaaa transparent',
      borderStyle: 'solid',
      borderWidth: '0 4px 5px 4px',
      position: 'absolute',
      right: '13px',
      transform: 'rotate(90deg)',
      top: '19px',
    },
    dropDownContent: {
      position: 'absolute',
      minWidth: '160px',
      backgroundColor: '#fff',
      zIndex: 5,
      width: '99.25%',
      border: '1px solid #aaa',
      top: '30px',
      borderRadius: '0px',
      display: 'block',
      a: {
        color: '#024579',
        padding: '25px 10px',
        textDecoration: 'none',
        display: 'block',
        margin: 0,
        overflowX: 'hidden',
        '&:hover': {
          backgroundColor: '#5897fb',
          color: 'white',
        },
      },
      span: {
        padding: '6px',
        lineHeight: '1.42857',
      },
    },
  },
  selectedNetworkImageContainer: {
    marginTop: '-0.875em',
    alignSelf: 'flex-start',
    cursor: 'pointer',
  },

  selectedNetworkImage: {
    width: '120px',
    minWidth: '120px',
    height: '32px',
    objectFit: 'contain',
    paddingTop: '8px',
    paddingBottom: '8px',
    paddingLeft: '8px',
    cursor: 'pointer',
  },

  selectedNetworkName: {
    minWidth: '155px',
    lineHeight: '46px',
    textAlign: 'left',
    fontWeight: '625',
    fontSize: '1.25em',
    marginTop: '-12px',
    marginRight: '8px',
    marginLeft: '8px',
    cursor: 'pointer',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  selectedNetworkNameNoImage: {
    minWidth: '282px',
    lineHeight: '46px',
    textAlign: 'left',
    fontWeight: '600',
    fontSize: '1.25em',
    marginTop: '-12px',
    marginRight: '8px',

    cursor: 'pointer',
    marginLeft: '1.25em',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  dropDownIcon: {
    marginBottom: '14px',
    cursor: 'pointer',
  },
  fillerPointer: {
    cursor: 'pointer',
  },
}

export default Styles
